import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { NotificationService } from '../../core/services/notification.service';

declare var $: any;


@Injectable()
export class BodyService {

  public $body: any;

  constructor(private httpClient: HttpClient,
              private router: Router,
              protected notificationService: NotificationService) {
    this.$body = $('body');
  }


  public addClass(className: string) {
        this.$body.addClass(className)
  }

  public removeClass(className: string) {
        this.$body.removeClass(className)
  }

  public toggleClass(className: string, state?: boolean) {
        this.$body.toggleClass(className, state)
  }
    public getToken(): string {
        //// debugger;
        let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
        let selectModule = sessionStorage.getItem('selectModule'); 
        if (currentUser && currentUser.token) {
            if(selectModule == 'true'){
               return  sessionStorage.getItem('token');
            }
            else{
                return sessionStorage.getItem('tokenIni');
            } 
        }
        return '';
    }

    // sample method from angular doc
    public handleError (error: any) {
        // debugger;
        let encontroError:boolean = false;
        let errMsg = "";
        // debugger;
        if (error.status === 401 ) {
            //window.location.href = '/';
            errMsg = "Usuario / Password Incorrecto.";
            encontroError = true;
        }

        if (!encontroError) {
            if (error.status === 405) {
                errMsg = "Usuario no tiene PERMISOS para la ejecución de dicho Método";
                encontroError = true;
            }
        }

        let token = sessionStorage.getItem('token');
        if (!encontroError) {
            if (error.url == null) {
                if (token != null && (error.status == 0) && (error.statusText == "" || error.statusText == "Unknown Error")) {
                    sessionStorage.setItem('expiracion', 'S');
                    encontroError = true;
                }
            }
        }

        if (!encontroError) {
            if (error.url == null && (token == null || token == '')) {
                errMsg = "No se pudo establecer comunicación con el Servidor";
                encontroError = true;
            }
        }

        if (!encontroError) {
            if (error.url.indexOf("/api/login") !== -1) {
                errMsg = "Usuario / Password Incorrecto!!";
                encontroError = true;
            }
        }

        if (!encontroError) {
            let errorException = error.error;
            errMsg = "<br/><em>Excepción: " + errorException.error +
                "</em><br/><strong>Mensaje: " + errorException.message ;
        }

        this.notificationService.smallBoxError(errMsg);

    }




    public showPopupSessionExpirada(){
        this.notificationService.smartMessageBox({
            title : "<h1><i class='fa fa-sign-out txt-color-orangeDark'></i>&nbsp;Cerrar Sesión</h1> <span class='txt-color-orangeDark'><strong>" + $('#show-shortcut').text() + "</strong></span>",
            content : 'Sesión Expirada',
            buttons : '[Aceptar]'

        }, (ButtonPressed) => {
            if (ButtonPressed == "Aceptar") {
                this.logout();
                this.router.navigate(['/auth/login']);
                window.location.reload();
            }
        });
    }

    public logout(){
        localStorage.removeItem('rutaServidor');
        sessionStorage.removeItem('currentUser');
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('expiracion');
        sessionStorage.removeItem("listaSeguimiento");
        //localStorage.clear();
        sessionStorage.clear();

    }


}



// WEBPACK FOOTER //
// ./src/app/shared/_utils/body.service.ts